import Css from "../../style.module.scss";

import { FormElement } from "nlib/common/Form";
import { getActiveOrganization } from "selectors/organizations";
import { getAllBusinessesData, getSelectedBusinessId } from "selectors/businesses";
import { getTextsData } from "selectors/texts";
import { useMainApi } from "hooks";
import { useSelector } from "react-redux";
import Checkbox from "nlib/ui/Checkbox";
import FormLabel from "nlib/common/FormLabel";
import IntegrationServices from "const/IntegrationServices";
import React, { useMemo } from "react";
import SelectDefaultAccountant from "./lib/SelectDefaultAccountant";
import Texts from "utils/Texts";
import UiRoutes from "const/UiRoutes";
import UncategorizedTransactions from "./lib/UncategorizedTransactions";

const UncategorizedTab = ({ businessId, integrationService, hasBusinessUsers }) => {
  const { messages } = useSelector(getTextsData);

  const selectedBusinessId = useSelector(getSelectedBusinessId);

  const businessesData = useSelector(getAllBusinessesData);

  const { businessOrganization, ignoreUncategorizedTransactions } = useSelector(getActiveOrganization);

  const quickBooksBusiness = integrationService === IntegrationServices.QUICK_BOOKS.value;

  const integrationServiceLabel = useMemo(() => {
    return IntegrationServices.getByValue(integrationService).label;
  }, [integrationService]);

  const selectedBusinessData = useMemo(() => {
    return businessesData.find(({ id }) => id === businessId) || {};
  }, [businessId, businessesData]);

  const [businessData, fetching] = useMainApi({
    fetchCondition: selectedBusinessId !== businessId,
    initialData: selectedBusinessData,
    parameters: [`${UiRoutes.BUSINESSES}/${businessId}`]
  });

  const {
    extraData: { quickBooksClassification } = {},
    settings: { uncategorizedCategoryNames = [] } = {}
  } = businessData;

  return (
    <>
      <div className={Css.row}>
        <FormElement
          toggle
          name="allowApproveWithoutPayee"
          element={Checkbox}>
          <span>
            {Texts.replaceVars(
              messages.approveWithoutPayeeToggleLabelText,
              { system: integrationServiceLabel }
            )}
          </span>
        </FormElement>
      </div>
      {quickBooksBusiness && !ignoreUncategorizedTransactions && (
        <div className={Css.row}>
          <div className={Css.col}>
            <FormLabel>{messages.settingsUncategorizedLabel}</FormLabel>
            <UncategorizedTransactions
              disabled={fetching && (selectedBusinessId !== businessId)}
              classification={quickBooksClassification}
              uncategorizedCategoryNames={uncategorizedCategoryNames} />
          </div>
        </div>
      )}
      {(!businessOrganization || hasBusinessUsers) && (
        <>
          <FormLabel>{messages.accountantToAskClient}</FormLabel>
          <div className={Css.row}>
            <FormElement
              businessId={businessId}
              name="defaultClientAccountantEmail"
              element={SelectDefaultAccountant} />
          </div>
        </>
      )}
    </>
  );
};

export default UncategorizedTab;
